import { createSlice } from '@reduxjs/toolkit';
import { actionWeightSync } from './actions';
import { NAMESPACE } from './helpers';

interface State {
  sync: boolean
  isLoading: boolean
  error: Error | null
  _requestCount: number
}

const initState = (): State => {
  return {
    sync: false,
    isLoading: false,
    error: null,
    _requestCount: 0,
  };
};

const slice = createSlice({
  name: NAMESPACE,
  initialState: initState(),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(actionWeightSync.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(actionWeightSync.fulfilled, (state, action) => {
      state.sync = true;
      state.isLoading = false;
      state._requestCount++;
    });
    builder.addCase(actionWeightSync.rejected, (state, action) => {
      const { error } = action;
      state.isLoading = false;
      state.error = error;
    });
  },
});

export const reducerWeightSync = slice.reducer;
